module.exports = __webpack_public_path__ + "static/img/dyh.657e043.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dyh.jpg
// module id = Cwu2
// module chunks = 1